import { render, staticRenderFns } from "./DetailBooked.vue?vue&type=template&id=56d24aa4&scoped=true"
import script from "./DetailBooked.vue?vue&type=script&lang=js"
export * from "./DetailBooked.vue?vue&type=script&lang=js"
import style0 from "./DetailBooked.vue?vue&type=style&index=0&id=56d24aa4&prod&lang=scss&scoped=true"
import style1 from "./DetailBooked.vue?vue&type=style&index=1&id=56d24aa4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d24aa4",
  null
  
)

export default component.exports